<template>
  <public-layout>
    <div class="signin__header">
      <h1 v-bg-typography="'h1'">Welcome to Brainpeek</h1>
      <p v-bg-typography="'m-body'">a Braingineers product</p>
    </div>
    <transition name="fade">
      <div v-if="validToken">
        <form v-on:submit.prevent="postSignin" class="forms-container">
          <p v-bg-typography="'m-body'">
            You've now activated your account, go ahead and sign in to begin
            using Brainpeek
          </p>
          <h2 v-bg-typography="'h3'">Sign in</h2>
          <bg-field label="Email address" name="email">
            <bg-input name="email" v-model="signin.email" />
          </bg-field>
          <bg-field label="Password" name="email">
            <bg-input type="password" v-model="signin.password" />
          </bg-field>
          <div class="action-container">
            <bg-button
              :isLoading="isLoading"
              class="signin-button"
              text="Sign in"
              type="submit"
            />
            <router-link class="forgot-password" to="/forgot-password">
              <p v-bg-typography="'link'">Forgot your password?</p>
            </router-link>
          </div>
        </form>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="validToken === false">
        <p class="validation-sent" v-bg-typography="'m-body'">
          The email link has expired!
        </p>
      </div>
    </transition>
  </public-layout>
</template>

<style scoped>
.signup-button {
  display: inline;
}
.forms-container {
  max-width: 400px;
  margin: auto;
}
.names {
  display: flex;
  justify-content: space-between;
}
.name:first-child {
  margin-right: 10px;
}
.name:last-child {
  margin-left: 10px;
}
.action-container {
  display: flex;
  margin-top: 20px;
}
.forgot-password {
  flex-grow: 1;
  align-self: center;
  text-align: center;
}
.validation-sent {
  text-align: center;
  margin-top: 30px;
}

.signin__header {
  text-align: center;
  margin-bottom: 40px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-active {
  transition-delay: 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>

<script>
import PublicLayout from "@/layouts/public";
import BgTypography from "@/directives/bg-typography";
import BgField from "@/components/bg-field";
import BgInput from "@/components/bg-input";
import BgButton from "@/components/bg-button";
import BgCheckbox from "@/components/bg-checkbox";
import API from "@/api";

export default {
  name: "signup",
  components: {
    BgButton,
    BgInput,
    BgField,
    BgCheckbox,
    PublicLayout,
  },
  directives: {
    BgTypography,
  },
  data: () => ({
    validToken: null,
    isLoading: false,
    errors: {},
    signin: {
      password: "",
      email: "",
    },
  }),
  computed: {
    samePasswords() {
      return (
        this.signup.password === this.signup.password2 &&
        this.signup.password !== ""
      );
    },
  },
  methods: {
    activeCall() {
      API.user
        .confirm(this.$route.query.confirmation_token)
        .then((response) => {
          this.validToken = true;
        })
        .catch((error) => {
          this.validToken = false;
        });
    },
    postSignin() {
      this.isLoading = true;
      this.$store
        .dispatch("login", this.signin)
        .then(() => {
          this.$router.push("/demo");
        })
        .catch((err) => {
          this.isLoading = false;
        });
    },
  },
  created() {
    this.activeCall();
  },
};
</script>
